import Backbone from 'backbone'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import i18n from 'scoreboard/components/i18n'

var SyncedItemTooltip = Backbone.View.extend({

	events: {
		'click': 'showTooltip'
	},

	/**
	 * If item comes from a template, disable the delete button and add a
	 * tooltip explaining why the item can't be deleted. #27933
	 *
	 * @constructs
	 *
	 * @param {Object} el The element containing the disabled button that
	 * will receive the click event
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.attachTo The element the tooltip should be above
	 *
	 * @param {String} options.itemType The type of item that is synced
	 *
	 */

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$('.delete').addClass('is-disabled')
		return this
	},

	showTooltip: function(e) {
		this.tooltip = new Tooltip({
			attachTo: this.options.attachTo,
			content: i18n.get('template.synced.cantChange',
				this.options.itemType.toLowerCase()),
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}

})

export default SyncedItemTooltip


SyncedItemTooltip.__filename__ = 'components/synced-item-tooltip.js'
